import React, { useEffect } from "react";

// This component conditionally renders an icon based on the notification type.
const NotificationIcon = ({ type }) => {
  if (type === "success") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    );
  }

  if (type === "error") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    );
  }

  return null;
};

export default function Notification({ message, type, onDismiss }) {
  const successClasses = "bg-green-500";
  const errorClasses = "bg-[#931b1c]";
  const baseClasses =
    "fixed top-5 right-5 px-4 py-3 rounded-lg shadow-lg text-white flex items-center justify-between transition-transform transform z-50 max-w-sm w-full";

  const notificationClass = `${baseClasses} ${
    type === "success" ? successClasses : errorClasses
  }`;

  return (
    <div className={notificationClass} role="alert">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <NotificationIcon type={type} />
        </div>
        <div className="ml-3 text-sm font-medium">{message}</div>
      </div>
      <button
        onClick={onDismiss}
        className="ml-4 p-1 rounded-md hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white"
        aria-label="Close"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  );
}
